import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography, Avatar, Dropdown, MenuItem, Menu, MenuButton } from '@mui/joy';

import { useManager, useManagerUser } from '@/hooks'
import { useNavigate } from 'react-router-dom'

import i18n from '@/i18n'
import { AccountRow } from './AccountRow'
import { HBox } from './HBox';

export function AccountBanner({
    expanded,
    account
}) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1, aspectRatio: '16/6' }}>
            {expanded ? (
                <>
                    {account.node.banner_url && ( 
                        <img src={account?.node.banner_url ?? account?.node.image_url} style={{ width: '100%' }} />
                    )}
                    {account.node.avatar_url && (
                        <HBox>
                            <Avatar size={"lg"} src={account?.node.avatar_url} />
                            <Typography>{account.node.name}</Typography>
                        </HBox>
                    )}
                </>
            ) : (
                account.node.avatar_url ? ( 
                    <Avatar size={"sm"} src={account.node.avatar_url} />
                
                ) : (
                    <img src={account?.node.icon_url ?? account.node.banner_url ?? account.node.logotype_url} style={{ width: '48px' }} />
                )
            )}
        </Box>
    )
}

AccountBanner.propTypes = {
    expanded: PropTypes.bool.isRequired,
    account: PropTypes.object.isRequired
}

export function AccountSelect({
    expanded
}) {
    const navigate = useNavigate()
    const manager = useManager()

    const {
        managerUser,
        organizationUser,
        labelUser,
        accountsData
    } = useManagerUser()

    return (
        <Dropdown>
            <MenuButton aria-label={i18n.t('accounts')} variant="plain" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                {organizationUser && !labelUser &&  <AccountBanner account={organizationUser} expanded={expanded} />}
                {labelUser && <AccountBanner account={labelUser} expanded={expanded} />}
                {['artist', 'person', 'payee'].indexOf(manager?.type) !== -1 && managerUser && <AccountBanner account={managerUser} expanded={expanded} />}
            </MenuButton>
            <Menu>
                <MenuItem disabled={true}>{i18n.t('accounts')}</MenuItem>
                {accountsData.map((organizationUser) => (
                    <React.Fragment key={organizationUser.id}> 
                        <MenuItem
                            disabled={!organizationUser.can_view}
                            selected={organizationUser.node.type === manager?.type && organizationUser.node.slug === manager?.slug}
                            key={organizationUser.id}
                            onClick={() => navigate(`/${organizationUser.node.type}/${organizationUser.node.slug}`)}
                        > 
                            <AccountRow account={organizationUser} /> 
                        </MenuItem>
                        {organizationUser?.payee_users instanceof Array && organizationUser?.payee_users.map((labelUser) => (
                            <React.Fragment key={labelUser.id}>
                                <MenuItem disabled={!labelUser.can_view} sx={{ paddingLeft: 3 }} key={labelUser.id} onClick={() => navigate(`/${labelUser.node.type}/${labelUser.node.slug}`)}>
                                    <AccountRow account={labelUser} />
                                </MenuItem>
                            </React.Fragment>
                        ))} 
                        {organizationUser?.person_users instanceof Array && organizationUser?.person_users.map((labelUser) => (
                            <React.Fragment key={labelUser.id}>
                                <MenuItem disabled={!labelUser.can_view} sx={{ paddingLeft: 3 }} key={labelUser.id} onClick={() => navigate(`/${labelUser.node.type}/${labelUser.node.slug}`)}>
                                    <AccountRow account={labelUser} />
                                </MenuItem>
                            </React.Fragment>
                        ))} 
                        {organizationUser?.artist_users instanceof Array && organizationUser?.artist_users.map((labelUser) => (
                            <React.Fragment key={labelUser.id}>
                                <MenuItem disabled={!labelUser.can_view} sx={{ paddingLeft: 3 }} key={labelUser.id} onClick={() => navigate(`/${labelUser.node.type}/${labelUser.node.slug}`)}>
                                    <AccountRow account={labelUser} />
                                </MenuItem>
                            </React.Fragment>
                        ))} 
                        {organizationUser?.label_users instanceof Array && organizationUser?.label_users.map((labelUser) => (
                            <React.Fragment key={labelUser.id}>
                                <MenuItem disabled={!labelUser.can_view} sx={{ paddingLeft: 3 }} key={labelUser.id} onClick={() => navigate(`/${labelUser.node.type}/${labelUser.node.slug}`)}>
                                    <AccountRow account={labelUser} />
                                </MenuItem>
                                {labelUser?.artist_users instanceof Array && labelUser?.artist_users.map((artistUser) => (
                                    <MenuItem sx={{ paddingLeft: 5 }} key={artistUser.id} onClick={() => navigate(`/${artistUser.node.type}/${artistUser.node.id}`)}>
                                        <AccountRow account={artistUser} />
                                    </MenuItem>
                                ))}
                            </React.Fragment>
                        ))} 
                    </React.Fragment>
                ))}
                <hr />
                {accountsData?.length > 5 && <MenuItem onClick={() => navigate('/accounts/select')}>{i18n.t('more-accounts')}</MenuItem>}
                <hr />
                <MenuItem onClick={() => navigate('/accounts/logout')}>{i18n.t('logout')}</MenuItem>
            </Menu>
        </Dropdown>
    )
}

AccountSelect.propTypes = {
    expanded: PropTypes.bool.isRequired
}